import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export const resetIcons = ({ eventEmitter }: ApiMethodBase) => {
    eventEmitter.emit(Event.resetFilter);
};
